import { coerceIdArray } from '@griply/utils';
import { TaskType } from 'shared/types/task-base';
import {
  defaultUpcomingCalendarViewOptions,
  UpcomingCalendarViewOptions,
} from 'shared/types/upcoming-calendar-view-options';

const taskTypes = Object.values(TaskType);

const coerceTaskTypes = (value: unknown): TaskType[] =>
  Array.isArray(value)
    ? value.filter((item): item is TaskType =>
        taskTypes.includes(item as TaskType),
      )
    : [];

export const coerceUpcomingCalendarViewOptions = (
  value: unknown,
): UpcomingCalendarViewOptions => {
  if (!value || typeof value !== 'object') {
    return defaultUpcomingCalendarViewOptions;
  }

  const stored = value as Record<string, unknown>;

  return {
    hiddenTaskTypes: coerceTaskTypes(stored.hiddenTaskTypes),
    hiddenLifeAreaIds: coerceIdArray(stored.hiddenLifeAreaIds),
    hiddenCalendarIds: coerceIdArray(stored.hiddenCalendarIds),
    sectionOrder: coerceIdArray(stored.sectionOrder),
    hideFocusBlocks: stored.hideFocusBlocks === true,
    hideGoalDeadlines: stored.hideGoalDeadlines === true,
    hideExternalCalendarEvents: stored.hideExternalCalendarEvents === true,
    hideCompleted: stored.hideCompleted === true,
  };
};
